import { format } from 'date-fns';
import type { ChatMessage } from './types';
import { formatMessageTimestamp } from './formatMessageTime';
import { toLocalDateString } from '../../utils/eventDate';

// Save the conversation as a text file. Uses the same timestamp formatter as the
// on-screen transcript so the file and the UI cannot disagree about when
// something was said (WIPE-981).
export function downloadTranscript(messages: ChatMessage[], title: string): void {
  if (messages.length === 0) return;

  const text = [
    `Chat Transcript — ${title}`,
    `Date: ${format(new Date(), 'MMM d, yyyy h:mm:ss a')}`,
    '---',
    ...messages.map((m) => `[${formatMessageTimestamp(m.at)}] ${m.sender}: ${m.content}`),
  ].join('\n');

  const blob = new Blob([text], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `chat-transcript-${toLocalDateString(new Date())}.txt`;
  a.click();
  URL.revokeObjectURL(url);
}
